import { Box } from "@mui/material";
import React from "react";
import Construction from "../../components/Construction";

const SettingsPage = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Construction />
    </Box>
  );
};

export default SettingsPage;
